export const TicketAvailability = {
  NOT_AVAILABLE: 0,
  AVAILABLE: 1,
  SOLD_OUT: 2,
  COMING_SOON: 3,
  ENTRY_CLOSED: 4,
};
